"use client";

import React, { useState } from "react";
import Header from "../../../components/layout/header";
import Footer from "../../../components/layout/footer";

const COLORS = {
  primary: "#003B5C",
};

const FAQ_ITEMS = [
  {
    question: "What services are provided by DPU?",
    answer:
      "DPU offers several services, including: dormitory/guest house rentals, Lecture House (LH) rentals, room/meeting room rentals, venue rentals for filming/video production, and the provision of other supporting facilities.",
  },
  {
    question:
      "How can I book a room at UIII ?",
    answer:
      "After selecting the chosen service, room rental can be requested by submitting an official letter addressed to the Director of Business Development. For further information, please contact DPU’s official WhatsApp.",
  },
  {
    question:
      "Is the daycare open to the general public?",
    answer:
      "Yes, the Daycare facility is available for the public as long as the quota allocated for general users is still available. For more details, please contact DPU’s official WhatsApp.",
  },
  {
    question: "How do I make a payment for the rental?",
    answer:
      "Once your rental request is approved, we will issue an invoice that includes the total amount due and the bank account number for payment.",
  },
  {
    question: "What happens if there is damage to the facility during the rental period?",
    answer:
      "Renters are responsible for any damage caused due to negligence. Repair fees will be adjusted according to the level of damage",
  },
  {
    question: "Can I visit the location before making a reservation?",
    answer:
      "Yes, you may request a site visit schedule by contacting the DPU admin via WhatsApp.",
  },
  {
    question: "What are the requirements to become a DPU business partner ?",
    answer:
      "To become a DPU business partner, you may submit your business proposal via email to dpu@uiii.ac.id. After receiving your proposal, we will review it and provide feedback regarding the potential collaboration.",
  },
];

export default function FAQPage() {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleIndex = (index) => {
    setActiveIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F5F7FA]">
      <Header />

      <main className="flex-1 py-10 sm:py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-0">
          {/* Title */}
          <h1 className="text-center text-xl sm:text-2xl font-semibold tracking-wide text-[#003B5C] mb-8 sm:mb-10 uppercase">
            Frequently Asked Questions
          </h1>

          {/* FAQ list */}
          <div className="space-y-3 sm:space-y-4">
            {FAQ_ITEMS.map((item, index) => {
              const isActive = index === activeIndex;
              return (
                <div key={index} className="relative">
                  {/* Question bar */}
                  <button
                    type="button"
                    onClick={() => toggleIndex(index)}
                    className={`w-full flex items-center text-left rounded-md sm:rounded-lg px-4 sm:px-6 py-3 sm:py-3.5 text-sm sm:text-base font-semibold text-white shadow-sm transition-colors ${
                      isActive ? "bg-[#005A86]" : "bg-[#003B5C]"
                    }`}
                  >
                    {/* bullet kecil seperti di desain */}
                    <span className="mr-3 text-lg leading-none">▪</span>
                    <span>{item.question}</span>
                  </button>

                  {/* Dekorasi “kurung” di kiri saat aktif (mirip gambar) */}
                  {isActive && (
                    <span className="hidden sm:block absolute left-2 top-7 h-6 w-4 border-l-2 border-b-2 border-[#003B5C] rounded-bl-md bg-transparent" />
                  )}

                  {/* Answer */}
                  {isActive && (
                    <div className="bg-white px-6 sm:px-10 pb-4 pt-3 text-xs sm:text-sm text-[#003B5C] leading-relaxed border-x border-b border-[#E0E5EB] rounded-b-md sm:rounded-b-lg">
                      {item.answer}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
